import ViewAudienceSegment from "./ViewAudienceSegment";

export default ViewAudienceSegment